import { GET_COUNTRY_NAMES } from "./api-url.constants";
import { CountryNamesApiDTO } from "./dtos/country-names.dto";
import { mapCountryNamesApiDTOtoCountryNames } from "./mappers/country-names.mapper";
import { jsonFetch } from "@/lib/helpers";

export const getCountryNames = async (): Promise<string[]> => {
  const countryNamesDTO = await jsonFetch<CountryNamesApiDTO>(GET_COUNTRY_NAMES);
  return mapCountryNamesApiDTOtoCountryNames(countryNamesDTO.data);
};
